import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const RealestateIndustry = () => {
  const [isPrevIndDisabled, setIsPrevIndDisabled] = useState(true);
  const [isNextIndDisabled, setIsNextIndDisabled] = useState(false);

  const handleIndChange = (indSwiper) => {
    setIsPrevIndDisabled(indSwiper.isBeginning);
    setIsNextIndDisabled(indSwiper.isEnd);
  };

  return (
    <div>
      <div className="agent-our-slider rs-ind-slider">
        <Swiper
          className="rs-ind-our-swiper "
          spaceBetween={30}
          slidesPerView={3}
          centeredSlides={true}
          modules={[Navigation, A11y, Pagination]}
          pagination={{
            clickable: true,
          }}
          scrollbar={{ draggable: true }}
          navigation={{
            prevEl: ".rs-ind-prev-arrow",
            nextEl: ".rs-ind-nxt-arrow",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          onSlideChange={handleIndChange}
          onReachBeginning={() => setIsPrevIndDisabled(true)}
          onReachEnd={() => setIsNextIndDisabled(true)}
          onFromEdge={() => {
            setIsPrevIndDisabled(false);
            setIsNextIndDisabled(false);
          }}
        >
          <SwiperSlide>
            <div className="mt-5">
              <div className="rs-ind-outer-card one">
                <h5>Residential Real Estate</h5>
                <h6>Apartments, villas, condominiums.</h6>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="mt-5">
              <div className="rs-ind-outer-card two">
                <h5>Commercial Real Estate</h5>
                <h6>Office spaces, shopping malls, hotels.</h6>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="mt-5">
              <div className="rs-ind-outer-card three">
                <h5>Industrial Properties</h5>
                <h6>Warehouses, factories, logistics centers.</h6>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="mt-5">
              <div className="rs-ind-outer-card four">
                <h5>Agricultural Land </h5>
                <h6>Farmlands, vineyards, and forestry.</h6>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="agent-our-btn-wrapper rs-ind-btn-wrap">
          <button
            className={` rs-ind-prev-arrow ${
              isPrevIndDisabled ? "disabled" : ""
            }`}
            style={{
              color: isPrevIndDisabled ? "#fff" : "#fff",
              cursor: isPrevIndDisabled ? "not-allowed" : "pointer",
              background: isPrevIndDisabled ? "#9D9B98" : "#232323",
            }}
          >
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          <button
            className={` rs-ind-nxt-arrow ${
              isNextIndDisabled ? "disabled" : ""
            }`}
            style={{
              color: isNextIndDisabled ? "#fff" : "#fff",
              cursor: isNextIndDisabled ? "not-allowed" : "pointer",
              background: isNextIndDisabled ? "#9D9B98" : "#232323",
            }}
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RealestateIndustry;
